import { InitializingPage } from './InitializingPage'

export default InitializingPage
